// extracted by mini-css-extract-plugin
module.exports = {"screenReaderText":"ErrorView_screenReaderText__1riua","errorView":"ErrorView_errorView__3MJN2","isInAppFrame":"ErrorView_isInAppFrame__2dGLH"};